// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__qfl32","selected":"Chip_selected__16X0t"};